<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="600"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <v-form>
      <v-card>
        <v-card-title>支店/営業所切替</v-card-title>
        <v-divider />

        <v-card-text>
          <v-data-table
            :headers="tableHeaders"
            :items="tenants"
            disable-sort
            item-key="id"
            :items-per-page="-1"
            hide-default-footer
            single-select
            @click:row="tenantRowClickEvent"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            :disabled="!selectedTenant"
            color="info"
            @click="registerButtonClickEvent"
          >
            切替
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'OrderChangeTenantDialog',
  components: {},
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    }
  },
  data() {
    return {
      selectedTenant: null,
      singleSelect: true,
      tableHeaders: [
        { value: 'subscriber_number', text: '加入者番号' },
        { value: 'name', text: '加入者名称' },
      ],
      tenants: [],
    }
  },
  computed: {},
  watch: {
    enableDialog (newValue) {
      this.selectedTenant = null
      if (newValue) {
        this.setVariable()
      }
    }
  },
  created() {
  },
  methods: {
    ...mapActions('DriverTenant', {
      fetchTenants: 'index'
    }),
    ...mapActions('DriverAuthentication', {
      switchTenant: 'switchTenant',
    }),
    ...mapActions('DriverTenantConfiguration', {
      updateConfiguration: 'updateConfiguration'
    }),
    setVariable () {
      this.fetchTenants().then((content) => {
        this.tenants = content.tenants
      })
    },
    closeButtonClickEvent () {
      this.$emit('closeEvent')
    },
    registerButtonClickEvent () {
      this.switchTenant({ tenant: this.selectedTenant })
      this.updateConfiguration({tenant: this.selectedTenant})
      this.$emit('registerEvent')
    },
    tenantRowClickEvent (item, row) {
      this.selectedTenant = item
      row.select(true)
    },

  }
}
</script>

<style scoped>

</style>
